import React, { createContext, useContext, useEffect, useRef, useState } from "react";

const ThemeContext = createContext({ theme: "dark", setTheme: () => {} });

export const ThemeProvider = ({ children }) => {
  const switchTimerRef = useRef(null);
  const [theme, setThemeState] = useState(() => {
    if (typeof window === "undefined") return "dark";
    return localStorage.getItem("maxfit:theme") || "dark";
  });

  const setTheme = (t) => {
    setThemeState(t);
    try { localStorage.setItem("maxfit:theme", t); } catch (e) { /* ignore */ }
    if (typeof document !== "undefined") {
      document.documentElement.classList.add("theme-switching");
      if (switchTimerRef.current) window.clearTimeout(switchTimerRef.current);
      switchTimerRef.current = window.setTimeout(() => {
        document.documentElement.classList.remove("theme-switching");
      }, 220);
    }
  };

  useEffect(() => {
    document.documentElement.setAttribute("data-theme", theme);
  }, [theme]);

  useEffect(() => () => {
    if (switchTimerRef.current) window.clearTimeout(switchTimerRef.current);
  }, []);

  return (
    <ThemeContext.Provider value={{ theme, setTheme }}>
      {children}
    </ThemeContext.Provider>
  );
};

export const useTheme = () => useContext(ThemeContext);
